import { memo, useEffect, useRef, useState } from 'react';
import { Subscription } from 'rxjs';
import { useOnPathChange } from '@bridebook/web/lib/utils/hooks/use-on-path-change';
import { useServices } from '@bridebook/web/lib/utils/hooks/use-services';
import { lazyComponent } from '@bridebook/web/lib/utils/lazy/lazy-component';
import { IWarningModalPayload } from '@bridebook/web/lib/utils/warning-modal-service';

const WarningModal = lazyComponent<IWarningModalPayload>(
  () => import('@bridebook/web/components/bbcommon/warning-modal'),
);

const WarningModalLazy: React.FC = () => {
  const { warningModal } = useServices();
  const [modalState, setModalState] = useState<IWarningModalPayload | undefined>();
  const subscription = useRef<Subscription | undefined>(undefined);

  useEffect(() => {
    subscription.current = warningModal.subscribe((state) => {
      setModalState(state);
    });

    return () => {
      subscription.current?.unsubscribe();
      setModalState(undefined);
    };
  }, [warningModal]);

  useOnPathChange(() => {
    warningModal.toggleWarningModal();
  });

  if (!modalState) return null;

  return <WarningModal {...modalState} />;
};

export default memo(WarningModalLazy);
